import React from 'react';
import '../styles/footer.css';
import packageJSON from '../../package.json';
import config from '../config';

export default function Footer() {
    return (
        <div className="footer">
            <div className="container text-center py-5">
                <p>
                    {config.footer.title} <br/> 
                    {config.footer.description} {packageJSON.version}
                </p>
            </div>
        </div>
    )
}
